module.exports = __webpack_public_path__ + "assets/img/img2.42e0ea21.png";